export enum QueryKeys {
  AskTeacherQuestion = 'ask-teacher-question',
  AskTeacherCount = 'ask-teacher-count',
  WorkSchedule = 'work-schedule',
  NextLiveClass = 'next-live-class',
  OlderLiveClass = 'older-live-class',
  LiveClassTeacherReminderNotification = 'live-class-teacher-reminder-notification',
  LiveClassNotification = 'live-class-notification',
  Messages = 'messages',
  ActiveClasses = 'active-classes',
  StatusActiveClass = 'status-active-classes',
  AssistanceNotification = 'assistance-notification',
  RejoinClasses = 'rejoin-classes',
  GenericNotification = 'generic-notification',
}
